export default __webpack_public_path__ + "static/media/vector-previouswhite.a71c98b7.svg";